import React from 'react';
import { Building2, Scale, Globe, Target } from 'lucide-react';
import { FadeIn, Section, SectionLabel, ButtonSecondary } from './UI';
const services = [{
  icon: <Building2 className="w-6 h-6 text-brand-purple" data-id="element-17" />,
  title: 'Creación de Empresas',
  description: 'Registro e incorporación de LLCs y corporaciones en USA.'
}, {
  icon: <Scale className="w-6 h-6 text-brand-purple" data-id="element-18" />,
  title: 'Estructura Legal',
  description: 'Bases sólidas, licencias y cumplimiento normativo.'
}, {
  icon: <Globe className="w-6 h-6 text-brand-purple" data-id="element-19" />,
  title: 'Presencia Digital',
  description: 'Desarrollo web, e-commerce y ecosistemas digitales.'
}, {
  icon: <Target className="w-6 h-6 text-brand-purple" data-id="element-20" />,
  title: 'Estrategia de Marca',
  description: 'Posicionamiento, identidad visual y crecimiento.'
}];
export const AboutSection = () => {
  return <Section className="bg-white border-t border-brand-grayBg" data-id="element-21">
      <FadeIn data-id="element-22">
        <div className="flex flex-col lg:flex-row gap-12 items-center" data-id="element-23">
          {/* Left Column - Info */}
          <div className="lg:w-1/2" data-id="element-24">
            <SectionLabel data-id="element-25">Nuestra Agencia</SectionLabel>
            <h2 className="font-serif text-[clamp(1.9rem,4vw,2.8rem)] leading-[1.2] text-brand-dark mb-5 font-bold" data-id="element-26">
              Construimos negocios <br data-id="element-27" />
              <span className="text-brand-purple" data-id="element-28">reales y escalables.</span>
            </h2>
            <p className="text-[1.05rem] text-brand-dark/80 mb-6 leading-relaxed" data-id="element-29">
              Inkova es una empresa de consultoría y creación de negocios
              dedicada a ayudar a emprendedores latinos a establecer empresas
              sólidas en los Estados Unidos.
            </p>
            <p className="text-[1.05rem] text-brand-dark/80 mb-8 leading-relaxed" data-id="element-30">
              Más allá de esta guía, ofrecemos acompañamiento integral para
              transformar tu visión en una marca estructurada, legalmente
              protegida y lista para competir en el mercado digital.
            </p>
            <ButtonSecondary text="Explorar Servicios" href="https://go.inkovacreation.com/" data-id="element-31" />
          </div>

          {/* Right Column - Services Grid */}
          <div className="lg:w-1/2 grid grid-cols-1 sm:grid-cols-2 gap-5 w-full" data-id="element-32">
            {services.map((service, idx) => <div key={idx} className="bg-brand-grayBg p-6 rounded-[20px] border border-transparent hover:border-brand-purple/20 transition-all duration-300" data-id="element-33">
                <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center mb-4 shadow-sm" data-id="element-34">
                  {service.icon}
                </div>
                <h3 className="font-bold text-brand-dark text-[1.1rem] mb-2" data-id="element-35">
                  {service.title}
                </h3>
                <p className="text-[0.9rem] text-brand-dark/70 leading-relaxed" data-id="element-36">
                  {service.description}
                </p>
              </div>)}
          </div>
        </div>
      </FadeIn>
    </Section>;
};